/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule } from '@spartacus/core';
import {
  ConfiguratorExitButtonModule,
  ConfiguratorProductTitleComponent,
} from '@spartacus/product-configurator/rulebased';
import { IconModule, MediaModule } from '@spartacus/storefront';

@Component({
  selector: 'custom-configurator-product-title',
  templateUrl: './configurator-product-title.component.html',
  styleUrl: './configurator-product-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CommonModule,
    I18nModule,
    IconModule,
    MediaModule,
    ConfiguratorExitButtonModule,
  ],
})
export class CustomConfiguratorProductTitleComponent extends ConfiguratorProductTitleComponent {}
